import { SpacingBarSlugs } from "@/lib/elements/constants";
import { SpacingBarDescription } from "@/types/elements";

export function getSpacingBarsFromPresetSlug(
  slug: SpacingBarSlugs,
  twigPath: string
): SpacingBarDescription[] {
  function getSpaceBar(
    position: "outside" | "inside",
    property: "margin" | "padding",
    direction: "top" | "right" | "bottom" | "left",
    controlType: "control" | "complex" | "not_responsive"
  ) {
    let affectedPropertyPath = "";

    if (controlType === "control") {
      affectedPropertyPath = `${twigPath}.${property}_${direction}.%%BREAKPOINT%%`;
    } else if (controlType === "complex") {
      affectedPropertyPath = `${twigPath}.${property}.%%BREAKPOINT%%.${direction}`;
    } else {
      affectedPropertyPath = `${twigPath}.${property}.${direction}`;
    }

    return {
      location: `${position}-${direction}`,
      cssProperty: `${property}-${direction}`,
      affectedPropertyPath
    } as SpacingBarDescription;
  }

  const marginAll = [
    getSpaceBar("outside", "margin", "top", "complex"),
    getSpaceBar("outside", "margin", "bottom", "complex"),
    getSpaceBar("outside", "margin", "right", "complex"),
    getSpaceBar("outside", "margin", "left", "complex")
  ];

  const paddingAll = [
    getSpaceBar("inside", "padding", "top", "complex"),
    getSpaceBar("inside", "padding", "bottom", "complex"),
    getSpaceBar("inside", "padding", "right", "complex"),
    getSpaceBar("inside", "padding", "left", "complex")
  ];

  const marginY = [
    getSpaceBar("outside", "margin", "top", "control"),
    getSpaceBar("outside", "margin", "bottom", "control")
  ];

  const marginX = [
    getSpaceBar("outside", "margin", "right", "control"),
    getSpaceBar("outside", "margin", "left", "control")
  ];

  const paddingY = [
    getSpaceBar("inside", "padding", "top", "control"),
    getSpaceBar("inside", "padding", "bottom", "control")
  ];

  const paddingX = [
    getSpaceBar("inside", "padding", "right", "control"),
    getSpaceBar("inside", "padding", "left", "control")
  ];

  const allNotResponsive = [
    getSpaceBar("outside", "margin", "top", "not_responsive"),
    getSpaceBar("outside", "margin", "bottom", "not_responsive"),
    getSpaceBar("outside", "margin", "right", "not_responsive"),
    getSpaceBar("outside", "margin", "left", "not_responsive"),

    getSpaceBar("inside", "padding", "top", "not_responsive"),
    getSpaceBar("inside", "padding", "bottom", "not_responsive"),
    getSpaceBar("inside", "padding", "right", "not_responsive"),
    getSpaceBar("inside", "padding", "left", "not_responsive")
  ];

  switch (slug) {
    case "spacing_all":
      return [...marginAll, ...paddingAll];
    case "spacing_all_y":
      return [...marginY, ...paddingY];
    case "spacing_all_x":
      return [...marginX, ...paddingX];
    case "spacing_margin_all":
      return marginAll;
    case "spacing_margin_y":
      return marginY;
    case "spacing_margin_x":
      return marginX;
    case "spacing_padding_all":
      return paddingAll;
    case "spacing_padding_y":
      return paddingY;
    case "spacing_padding_x":
      return paddingX;
    case "spacing_all_not_responsive":
      return allNotResponsive;
  }
}
